import { render, staticRenderFns } from "./CareerSimulator.vue?vue&type=template&id=3559a484&scoped=true&"
import script from "./CareerSimulator.vue?vue&type=script&lang=js&"
export * from "./CareerSimulator.vue?vue&type=script&lang=js&"
import style0 from "./CareerSimulator.vue?vue&type=style&index=0&id=3559a484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3559a484",
  null
  
)

export default component.exports